import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function EuER(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Steuern & Auswertung"
      title="EÜR & GuV – Gewinnermittlung automatisch"
      subtitle="Saldify erstellt Ihre Einnahmen-Überschuss-Rechnung oder Gewinn- und Verlustrechnung automatisch aus Ihren Buchungen."
      heroImage="/screenshots/app-buchhaltung.webp"
      heroImageAlt="Einnahmenüberschussrechnung in Saldify mit Betriebseinnahmen und -ausgaben"
      features={[
        {
          title: 'Automatische EÜR',
          description: 'Ihre Einnahmen-Überschuss-Rechnung wird laufend aus allen Buchungen erstellt. Immer aktuell.',
        },
        {
          title: 'GuV für Bilanzierer',
          description: 'Für bilanzierungspflichtige Unternehmen erstellt Saldify die Gewinn- und Verlustrechnung.',
        },
        {
          title: 'Steuerkonform',
          description: 'Die Auswertungen entsprechen den Vorgaben des Finanzamts und können direkt eingereicht werden.',
        },
        {
          title: 'Monats- & Jahresvergleich',
          description: 'Vergleichen Sie verschiedene Zeiträume und erkennen Sie Trends und Entwicklungen.',
        },
        {
          title: 'Detaillierte Aufschlüsselung',
          description: 'Sehen Sie genau, welche Einnahmen- und Ausgabenkategorien Ihren Gewinn beeinflussen.',
        },
        {
          title: 'Export für Steuerberater',
          description: 'Exportieren Sie die EÜR im DATEV-Format oder als PDF für Ihren Steuerberater.',
        },
      ]}
      sections={[
        {
          title: 'Gewinn immer im Blick',
          description: 'Mit der automatischen EÜR sehen Sie jederzeit, wie profitabel Ihr Unternehmen läuft. Keine manuelle Berechnung, keine Tabellen – alles automatisch.',
          bullets: [
            'Betriebseinnahmen nach Kategorien',
            'Betriebsausgaben aufgeschlüsselt',
            'Vorläufiger Gewinn/Verlust',
            'Abschreibungen berücksichtigt',
          ],
          imageSide: 'right',
        },
        {
          title: 'Steuererklärung vorbereiten',
          description: 'Die EÜR aus Saldify entspricht der Anlage EÜR Ihrer Steuererklärung. Übertragen Sie die Werte oder lassen Sie Ihren Steuerberater direkt auf die Daten zugreifen.',
          bullets: [
            'Anlage-EÜR-konform',
            'Alle Zeilen automatisch befüllt',
            'Plausibilitätsprüfung',
            'Direkter ELSTER-Export möglich',
          ],
          imageSide: 'left',
        },
      ]}
      ctaTitle="Ihre EÜR auf Knopfdruck"
      ctaDescription="Vergessen Sie manuelle Berechnungen. Saldify erstellt Ihre Gewinnermittlung automatisch und korrekt."
    />
  );
}
